// extracted by mini-css-extract-plugin
export default {"icon_button_tooltip":"DeleteButton_icon_button_tooltip__mtDEQ","icon_button":"DeleteButton_icon_button__z1TUj"};